module.exports = __webpack_public_path__ + "static/media/vierateresa.bf289fe7.png";